import { render, staticRenderFns } from "./EducationProgressReportByTeacher.vue?vue&type=template&id=280faf96&"
import script from "./EducationProgressReportByTeacher.vue?vue&type=script&lang=js&"
export * from "./EducationProgressReportByTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports